import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export const initialState: { [key: string]: boolean } = {}

export const featureFlagsSlice = createSlice({
  name: 'customer',
  initialState,
  reducers: {
    setFeatureFlagsAction(state, action: PayloadAction<{ [key: string]: boolean }>) {
      return { ...state, ...action.payload }
    },
  },
})

export const { setFeatureFlagsAction } = featureFlagsSlice.actions

const featureFlagsReducer = featureFlagsSlice.reducer
export default featureFlagsReducer
